
function isValueValidToCallAPI (value) {
    if (value && value.trim().length > 2 && value.trim().length < 200 ) {
        return true
    }
    return false
}

export default isValueValidToCallAPI